
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 38.507H10.995a5.502 5.502 0 01-5.502-5.502v-22.01a5.502 5.502 0 015.502-5.502h22.01a5.502 5.502 0 015.502 5.502V22M38.507 38.507L35.09 35.09","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M31.17 25.668a5.502 5.502 0 110 11.005 5.502 5.502 0 010-11.005M38.507 14.664H5.493","stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M25.208 20.991a.09.09 0 100 .18.09.09 0 000-.18M18.788 20.991a.088.088 0 00-.087.09.09.09 0 10.087-.09M12.37 20.991a.088.088 0 00-.09.092.09.09 0 10.087-.09M18.788 26.493a.088.088 0 00-.087.09.09.09 0 10.087-.09M12.37 26.493a.088.088 0 00-.09.092.09.09 0 10.087-.09M18.788 31.998a.088.088 0 00-.087.09.09.09 0 10.087-.09M12.37 31.998a.088.088 0 00-.09.09.09.09 0 10.087-.09","stroke":"#363636","stroke-width":"3","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    